import { ImeiAlias } from '@addins/pn/services/unit-activity-selector/unit-activity-selector.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListNameValue } from '@models/imported/SagaSchema/ListObjects/ListNameValue';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { CommunicationEquipment_abstract } from '@models/imported/abstract/SagaSchema/CommunicationEquipment_abstract';
import { RefreshTokenStorageService } from '@services/refresh-token-storage/refresh-token-storage.service';
import { IUnitSetup } from '@techwan/ionic-core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface IUpdateRequestArgs {
  activityUid: string;
  addedVehicles: [];
  addedEquipments: CommunicationEquipment_abstract[];
  removedVehicles: [];
  removedEquipments: [];
}

@Injectable({
  providedIn: 'root'
})
export class UnitActivityProxyService {
  constructor(private http: HttpClient, private readonly token: RefreshTokenStorageService) {}

  getAvailableRfgiImei(): Observable<ListNameValue<ImeiAlias>[]> {
    return this.http.get<ListNameValue<ImeiAlias>[]>('api/RfgiImei/GetAvailableRfgiImei');
  }

  associateWithIdentifier(data: any): Observable<boolean> {
    const user = this.token.read().login.SagaUserAuth;
    return this.http.post<boolean>(
      'api/UnitActivity/AssociateUnitActivityWithIdentifier',
      Object.assign({}, data, {
        owner: user.SiteId,
        ownerName: user.OwnerName,
        userId: user.UserID,
        userName: user.UserName
      })
    );
  }

  createUnitActivity(data: any): Observable<boolean> {
    return this.http
      .post<string>('api/UnitActivity/Create', data, { responseType: 'text' as 'json' })
      .pipe(map(res => res === '"OK"'));
  }

  updateUnitActivity(updateRequest: IUpdateRequestArgs): Observable<UnitActivity> {
    return this.http
      .post('api/UnitActivity/UpdateUnit', updateRequest)
      .pipe(catchError((err, caught: Observable<UnitActivity>) => this.handleError(err, caught)));
  }

  joinUnitActivity(resourceName: string): Observable<boolean> {
    return this.http.post<boolean>('api/UnitActivity/Join', { resourceName });
  }

  getUnitActivities(filterStatus: number): Observable<IUnitSetup[]> {
    const args = {
      siteId: this.token.read().login.SagaUserAuth.Owner,
      filterStatus
    };
    return this.http.post<IUnitSetup[]>('api/UnitActivity/GetUnitActivities', args);
  }

  getAllUnitActivitiesCallSign() {
    return this.http.get<any[]>('api/UnitActivity/GetAllUnitActivitiesCallSign');
  }

  private handleError(err: any, caught: Observable<UnitActivity>): Observable<UnitActivity> {
    return of(null);
  }
}
